<template>
  <div class="d-flex content-sale flex-70 space-between align-center">
		<div class="d-flex align-center wrap section-sale">
			<button
				type="button"
				class="btn-sale"
				@click="goTo('home')"
			>Continuar haciendo compras</button>
			<div class="text-sale">
				<span class="text-bold">Carrito de compras</span>
				<span class="text-gray ml-1">|</span>
				<span class="text-gray ml-1">{{productQuantity}}</span>
			</div>
		</div>
		<button
			type="button"
			class="btn-empty"
			@click="carEmpty"
		>Vaciar el carrito</button>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

function productQuantity() {
	const msg = this.getTotalQuantity > 1 ? 'productos' : 'producto';
	return `${this.getTotalQuantity} ${msg}`;
}

function goTo(name) {
	this.$router.push({ name });
}

function carEmpty() {
	this.$store.commit('CLEAN_ORDER');
	this.$store.commit('UPDATE_PRODUCTS_SELECTED');
	this.$store.commit('UPDATE_RESPONSIBLE_VALID_DATA');
	this.$store.commit('SET_BILLING_DATA');
	this.$store.commit('UPDATE_DELIVERY_ADDRESS');
	this.$store.commit('SET_SHIPPING_COST', null);
	this.$store.commit('UPDATE_FLAG_PICK_UP');
	this.$router.push({ name: 'home' });
}

export default {
	name: 'component-sale',
	computed: {
		...mapGetters([
			'getTotalQuantity',
		]),
		productQuantity,
	},
	methods: {
		carEmpty,
		goTo,
	},
	props: {
		quantity: {
			default: 0,
			type: [String, Number],
		},
	},
};
</script>

<style lang="scss" scoped>
button {
	background-color: color(buttonSale);
	border: solid 0.1rem color(leadLight);
	color: color(btnCar);
	font-family: font(open-regular);
	font-size: size(medium);
	padding: 0.8rem 1.5rem;
}

.content-sale {
	margin: 2.2rem 0;
}

.text-bold {
	font-family: font(open-bold);
	font-size: size(medium);
}

.text-gray {
	color: color(textProduct);
	font-size: size(medium);
}

.btn-empty {
	width: 17.2rem;
	@media (max-width: 425px) {
		display: none;
	}
}

.text-sale {
	margin-left: 1.2rem;
	
	@media screen and (max-width: 425px) {
		margin: 1.2rem 0 0 0;
	}
}

.section-sale {
	@media screen and (max-width: 425px) {
		padding-left: 1.5rem;
	}
}
</style>



// WEBPACK FOOTER //
// componentSale.vue?36a94fe6